import { render, staticRenderFns } from "./RecipesGallery.vue?vue&type=template&id=d40dea88&scoped=true"
import script from "./RecipesGallery.vue?vue&type=script&lang=ts"
export * from "./RecipesGallery.vue?vue&type=script&lang=ts"
import style0 from "./RecipesGallery.vue?vue&type=style&index=0&id=d40dea88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40dea88",
  null
  
)

export default component.exports
import {QScrollArea,QChip,QVirtualScroll,QCard,QImg,QBtn,QCardSection,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QChip,QVirtualScroll,QCard,QImg,QBtn,QCardSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
